import {FC, ReactNode, useState} from 'react';

interface IModalContainer {
  sideEffect?: (setLoading: (bool: boolean) => void) => any;
  renderModal: (sideEffect: () => any, loading: boolean) => ReactNode;
}

export const ModalContainer: FC<IModalContainer> = ({sideEffect, renderModal}) => {
  const [loading, setLoading] = useState(false);

  const sideEffectWrapper = sideEffect ? () => sideEffect(setLoading) : () => {};

  return <>{renderModal(sideEffectWrapper, loading)}</>;
};
